import React, { useState } from "react";

import Section from "../../ui/components/Section/Section";

import useHasRight from "../../authorization/hooks/useHasRight";
import ProducerDashboard from "../../dashboard/components/Dashboard/ProducerDashboard";

import AlertsWidget from "../components/AlertsWidget/AlertsWidget";
import DiscussionsFeedWidget from "../components/DiscussionsFeedWidget/DiscussionsFeedWidget";
import FavoriteProductionsWidget from "../components/FavoriteProductionsWidget/FavoriteProductionsWidget";
import HomeLanguageDropdown from "../components/HomeLanguageDropdown";
import MyProductionsWidget from "../components/MyProductionsWidget/MyProductionsWidget";
import NotificationsWidget from "../components/NotificationsWidget/NotificationsWidget";
import OffersWidget from "../components/OffersWidget/OffersWidget";
import TodosWidget from "../components/TodosWidget/TodosWidget";
import HomeLayout from "../layouts/HomeLayout/HomeLayout";

const maxWidth = 1800;

export default function HomeProducerView({ organization }) {
	const hasRight = useHasRight();

	const [language, setLanguage] = useState(null);

	return (
		<>
			{hasRight("admin") && (
				<Section maxWidth={1600}>
					<ProducerDashboard organization={organization} />
				</Section>
			)}

			<Section maxWidth={maxWidth}>
				<HomeLanguageDropdown
					organization={organization}
					language={language}
					onChange={(value) => setLanguage(value)}
				/>

				<HomeLayout>
					<HomeLayout.LeftColumn>
						<NotificationsWidget organization={organization} language={language} />

						<TodosWidget organization={organization} language={language} />

						<OffersWidget organization={organization} language={language} />
					</HomeLayout.LeftColumn>

					<HomeLayout.RightColumn>
						{hasRight("discussions.feed") && (
							<DiscussionsFeedWidget organization={organization} language={language} />
						)}

						<AlertsWidget organization={organization} language={language} />

						<FavoriteProductionsWidget organization={organization} language={language} />

						<MyProductionsWidget organization={organization} language={language} />
					</HomeLayout.RightColumn>
				</HomeLayout>
			</Section>
		</>
	);
}
